import { createComponent } from '@carvana/vdp-components';

type OwnProps = React.PropsWithChildren<{
  className?: string;
}>;

const StyledPill = createComponent('button', {
  className: [
    'bg-white border border-solid border-grey-2',
    'flex min-h-[32px] items-center py-6 px-12 rounded-[100px]',
    't-body-s text-blue-6'
  ].join(' ')
});

const Pill = ({ className, children }: OwnProps) => (
  <StyledPill className={className}>{children}</StyledPill>
);

export default Pill;
